import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { DiscountListItem } from 'app/pages/DiscountsList/modules/DiscountItemsList/state';
import { getDiscountsToDisplay } from 'app/pages/DiscountsList/modules/DiscountItemsList';
import { Action } from 'app/pages/DiscountsList/actionTypes';
import DiscountItem from 'app/pages/DiscountsList/components/DiscountItem';
import { Typography, Empty, Pagination, theme } from 'antd';
import { ListLayout, ListLayoutItem } from 'app/shared/ui/ListLayout';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useToken } = theme;

interface StateProps {
    list: DiscountListItem[],
}

interface DispatchProps { }

const DiscountItemsList: React.FC<StateProps & DispatchProps> = ({ list }) => {
    const { token } = useToken();
    const [currentPage, setCurrentPage] = React.useState(1);
    const pageSize = 10;

    const paginatedData = list.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    if (list.length === 0) {
        return (
            <Empty
                image={<InfoCircleOutlined style={{ fontSize: 48, color: token.colorPrimary }} />}
                styles={{ image: { marginBottom: token.margin } }}
                description={
                    <>
                        <Text strong style={{ fontSize: token.fontSizeLG }}>
                            No results
                        </Text>
                        <Text type="secondary" style={{ display: 'block', marginTop: token.marginXS }}>
                            There were no results found that matched your search criteria
                        </Text>
                    </>
                }
            />
        );
    }

    return (
        <div style={{ padding: token.padding }}>
            <ListLayout itemLayout="vertical" size="large" style={{ marginBottom: token.marginLG }}>
                {paginatedData.map((item) => (
                    <ListLayoutItem key={item.id}>
                        <DiscountItem discount={item} />
                    </ListLayoutItem>
                ))}
            </ListLayout>
            {list.length > pageSize && (
                <div style={{ textAlign: 'center' }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={list.length}
                        onChange={setCurrentPage}
                        showSizeChanger={false}
                    />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state: any): StateProps => ({
    list: getDiscountsToDisplay(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountItemsList);


